<template>
    <SiteHeader></SiteHeader>

    <main>
      <router-view v-slot="{ Component, route }" >
        <!-- meta.keepAlive === true 인 화면만 캐싱 -->
        <!-- 1) meta.keepAlive === true 인 화면만 캐시 -->
        <keep-alive>
          <component
            v-if="route.meta.keepAlive"
            :is="Component"
            :key="route.fullPath"
          />
        </keep-alive>

        <!-- 2) 나머지는 항상 새로 렌더 (keep-alive 바깥) -->
        <component v-if="!route.meta.keepAlive" :is="Component" :key="route.fullPath" />

      </router-view>
    </main>

    <SiteFooter></SiteFooter>

    <loading 
      :active="isLoading" 
      :can-cancel="true" 
      :is-full-page="true"
      :on-cancel="loadingStop"
      :z-index="9999"
      >
      <img :src="gifSrc" alt="Loading..." style="width:120px;height:120px;object-fit:contain" @click="loadingStop" />

      </loading>
</template>

<script>

// @ is an alias to /src
import SiteHeader from '@/components/common/SiteHeader.vue'; //import 헤더 추가
import SiteFooter from '@/components/common/SiteFooter.vue'; //import 풋터 추가

import BreedsStore from '@/utils/breedsStore';
import LocationStore from '@/utils/locationStore';

import 'vue-loading-overlay/dist/css/index.css'
import Loading from 'vue-loading-overlay'

const GIF_URL = new URL('@/assets/img/loading_progress_image.gif', import.meta.url).href

export default {

  components: {
    SiteHeader, SiteFooter,Loading,
  },
  data() {
    return {

      isLoading: false, gifSrc: GIF_URL,

      breeds_version: '',
      location_version: '',

    }
  },
  methods: {

    loadingStart(){
      this.isLoading = true;
    },
    loadingStop(){
      this.isLoading = false;
    },

    getBreedsVersion(){
      const me = this;
      me.axios.get('breeds/version')
      .then(function (res) {
        if (res.status !== 200) return;

          me.breeds_version = res.data + ""; 

          const localVersion = BreedsStore.getVersion();

          // 버전이 없거나, 캐시가 없거나, 버전이 다르면 목록 갱신
          if (!me.breeds_version || localVersion !== me.breeds_version) {

            me.getBreedsList();
          }
      })
      .catch(function (error) {
        // console.log(error);
      });
    },

    getBreedsList(){
      const me = this;
      me.axios.get('breeds')
      .then(function (res) {
        if (res.status === 200) {
          // 응답 형태에 맞게 배열 추출 (필요 없으면 res.data로 단순화 가능)
          const list =
            Array.isArray(res.data?.breeds) ? res.data.breeds :
            Array.isArray(res.data)         ? res.data :
            Array.isArray(res.data?.list)   ? res.data.list : [];

          // ✅ 저장 전에 기존 리스트 삭제
          localStorage.removeItem('breeds');

          // ✅ 유틸로 저장(리스트만 저장; 버전은 위에서 따로 setVersion)
          BreedsStore.setAll(list);

          BreedsStore.setVersion(me.breeds_version);

        }
      })
      .catch(function (error) {
        // console.log(error);
      });
    },

    getLocationVersion(){
      const me = this;
      me.axios.get('location/version')
      .then(function (res) {
        if (res.status !== 200) return;

          me.location_version = res.data + ""; 

          const localVersion = LocationStore.getVersion();

          // 버전이 없거나, 캐시가 없거나, 버전이 다르면 목록 갱신
          if (!me.location_version || localVersion !== me.location_version) {

            // ✅ 목록 저장 성공 후에 버전 저장
            me.getLocationList();
          }
      })
      .catch(function (error) {
        // console.log(error);
      });
    },

    getLocationList(){
      const me = this;
      me.axios.get('location')
      .then(function (res) {
        if (res.status === 200) {
          // 응답 형태에 맞게 배열 추출 (필요 없으면 res.data로 단순화 가능)
          const list =
            Array.isArray(res.data?.locations) ? res.data.locations :
            Array.isArray(res.data)         ? res.data :
            Array.isArray(res.data?.list)   ? res.data.list : [];

          // ✅ 저장 전에 기존 리스트 삭제
          localStorage.removeItem('locations');

          // ✅ 유틸로 저장(리스트만 저장; 버전은 위에서 따로 setVersion)
          LocationStore.setAll(list);

          LocationStore.setVersion(me.location_version);

        }
      })
      .catch(function (error) {
        // console.log(error);
      });
    },

    getImageUrl(path){
      return this.image_server + path;
    },
  },
  mounted(){

  },
  created (){

    this.getBreedsVersion();
    this.getLocationVersion();

  },
  computed(){

  }
  
}
</script>

<style>

</style>
